import * as React from 'react';
import { useAgentDesktopHistory } from './agent-thread-history';

/** Container width, rather than the page viewport, controls rails in resizable drawers. */
export function useAgentRailLayout(compact: boolean) {
  const fallback = useAgentDesktopHistory(compact);
  const ref = React.useRef<HTMLDivElement>(null);
  const [width, setWidth] = React.useState<number>();
  React.useEffect(() => {
    const node = ref.current;
    if (!node || typeof ResizeObserver === 'undefined') return;
    const update = (next: number) => { if (next > 0) setWidth(next); };
    update(node.getBoundingClientRect().width);
    const observer = new ResizeObserver(entries => {
      const entry = entries.find(item => item.target === node);
      if (entry) update(entry.contentRect.width);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return { ref, chats: width === undefined ? fallback : width >= 768, prompts: width === undefined ? fallback : width >= 1024 };
}
